import { AxiosRequestConfig } from 'axios';

interface Update {
  enabled: boolean;
}

interface UpdateConfig extends AxiosRequestConfig {
  body: Update;
  data: Update;
  method: 'PATCH';
  url: `/student_in_classes/${string}/problemtypes/${string}`;
}

/**
 * PATCH /api/v2/student_in_classes/{id}/problemtypes/{type}
 *
 * { enabled: boolean }
 */
export const update = (
  studentInClassId: string,
  problemtypeType: string,
  data: Update,
): UpdateConfig => {
  return {
    method: 'PATCH',
    url: `/student_in_classes/${studentInClassId}/problemtypes/${problemtypeType}`,
    body: data,
    data,
  } as const;
};
